import { Route } from "@angular/router";

export const storeRoutes: Route[] = [
    {
        path: "shopping-cart",
        loadComponent: () =>
            import("../pages/shopping-cart/shopping-cart.page"),
    },
    {
        path: "product/payment/:result",
        loadComponent: () =>
            import("../pages/payment/result/payment-result.page"),
    },
    {
        path: "store",
        title: `스토어`,
        children: [
            {
                path: "",
                loadComponent: () => import("../pages/store/store.page"),
            },
            {
                path: ":id",
                loadComponent: () =>
                    import("../pages/store/product-detail/product-detail.page"),
            },
        ],
    },
];
